import React from 'react'

import { Icon, SplitContentContainer } from 'src/chrome'
import { FlexColumn } from 'src/styled'

import planContentStyles from '../PlanContentsGrid/planContentsGrid.module.scss'

const styles = {
  column: {
    width: '50%',
    alignItems: 'center',
    margin: '15px auto',
  },
  iconWrapper: {
    width: 80,
    marginBottom: 20,
  },
}

type Props = {
  screenWidth?: number
}

const AccountStorage: React.FC<Props> = props => {
  const { screenWidth } = props

  const baseIconProps = {
    color: '#9C9CA0',
    size: 80,
  }

  return (
    <div
      className={`${planContentStyles.featureGridContainer} ${planContentStyles.offWhite}`}
      style={{
        padding: '85px 0 135px 0',
      }}
    >
      <div className={planContentStyles.featureGrid}>
        <h1>Account Storage</h1>
        <br />
        <SplitContentContainer
          withSplitBorder={false}
          containerStyle={{ width: '100%' }}
          stack={(screenWidth || 1000) <= 800}
        >
          <FlexColumn css={styles.column}>
            <div css={styles.iconWrapper}>
              <Icon {...baseIconProps} icon={'FUNNEL'} size={64} />
            </div>
            <h5 style={{ color: '#6A6A6A' }}>Enhanced Storage</h5>
            <br />
            <div>
              <p
                style={{
                  fontSize: '16px',
                  color: '#6f8394',
                  marginTop: '9px',
                }}
              >
                Enhanced storage allows you save 500 cards, 1,000 pictures, 100
                campaigns, and 500 contacts.
              </p>
            </div>
          </FlexColumn>
          <FlexColumn css={styles.column}>
            <div css={styles.iconWrapper}>
              <Icon {...baseIconProps} icon={'EQUALIZER'} size={64} />
            </div>
            <h5 style={{ color: '#6A6A6A' }}>Premium Storage</h5>
            <br />
            <div>
              <p
                style={{
                  fontSize: '16px',
                  color: '#6f8394',
                  marginTop: '9px',
                }}
              >
                Premium storage allows you to save unlimited cards, pictures,
                campaigns, and contacts.
              </p>
            </div>
          </FlexColumn>
        </SplitContentContainer>
      </div>
    </div>
  )
}

export default AccountStorage
